import type { IntlShape } from "@formatjs/intl";
import { Skeleton } from "antd";
import { connect, type DispatchProp } from "react-redux";
import ConnectedAppLayout from "../../AppLayout";
import type { RootState } from "../../store";
import type { Location, PaginatedturbineResultsSideloadList } from "../../generated-axios-client";
import type { SideloadedTurbineInfo } from "../../../features/turbine/turbineSlice";
import { LocationViewRender } from "./LocationViewRender";

type LocationViewProps = {
	intl: IntlShape;
	location: Location | null;
	turbines: PaginatedturbineResultsSideloadList;
	turbineSideload: SideloadedTurbineInfo | null;
};

const LocationView = (props: LocationViewProps & DispatchProp) => {
	const { intl, location, turbines, turbineSideload, dispatch } = props;

	if (!location) {
		return <Skeleton active />;
	}

	return (
		<ConnectedAppLayout>
			<LocationViewRender
				intl={intl}
				location={location}
				turbines={turbines}
				turbineSideload={turbineSideload}
				dispatch={dispatch}
			/>
		</ConnectedAppLayout>
	);
};

export const ConnectedLocationViewPage = connect((state: RootState) => ({
	intl: state.intl.datetimeIntl,
	location: state.location.location,
	turbines: state.turbine.list as PaginatedturbineResultsSideloadList,
	turbineSideload: state.turbine.sideload,
}))(LocationView);

export default ConnectedLocationViewPage;
